export default __webpack_public_path__ + "static/media/plus.997072e6.svg";